var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRandomPrompt = function SvgRandomPrompt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.5,
    d: "M7 7.758a.44.44 0 0 1-.222-.058l-5.15-2.98a.439.439 0 1 1 .443-.758L7 6.812l4.9-2.835a.444.444 0 0 1 .6.158.444.444 0 0 1-.157.6L7.228 7.7A.55.55 0 0 1 7 7.758"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.5,
    d: "M7 13.043a.44.44 0 0 1-.437-.437V7.315A.44.44 0 0 1 7 6.877a.44.44 0 0 1 .438.438v5.29a.44.44 0 0 1-.438.438"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.5,
    d: "M7 13.27c-.513 0-1.02-.11-1.423-.332l-3.115-1.732C1.616 10.739.957 9.613.957 8.646V5.348c0-.968.659-2.088 1.505-2.56l3.115-1.727c.799-.444 2.047-.444 2.846 0l3.115 1.732c.846.467 1.505 1.593 1.505 2.561v3.296c0 .968-.659 2.088-1.505 2.56l-3.115 1.727c-.402.222-.91.333-1.423.333M7 1.605c-.367 0-.73.076-.997.222L2.888 3.558c-.56.31-1.056 1.15-1.056 1.791v3.296c0 .642.496 1.482 1.056 1.797l3.115 1.732c.53.298 1.464.298 1.994 0l3.116-1.732c.56-.315 1.055-1.15 1.055-1.797V5.35c0-.641-.495-1.481-1.055-1.796L7.998 1.82c-.269-.14-.63-.216-.998-.216"
  })));
};
export default SvgRandomPrompt;